export default __webpack_public_path__ + "static/media/laundry2-beforeB-1920w.93dc974a.webp";